import React from 'react'
import PropTypes from 'prop-types'
import qs from 'query-string'
import {Http, Credential, BASE_URL} from 'common'
import {AuthOptions} from '../../utils'

import {
    AuthPage, Window, TabBar, Form, Input,
    Checkbox, PhoneHint, PasswordHint,
    Parallax, License, Providers, ProviderItem,
    LinkButton
} from 'common/components'

import {Link} from 'react-router-dom'
import {Row, Col, Tooltip, Popover} from 'antd'


export default class SignUp extends AuthPage {
    config = {
        namespace: 'registrations',
        url: 'api/users/signup',
        repeat: 'api/users/signup/resend',

        typeOf: ({login}) =>
            (Credential.typeOf(login)),

        sanitize: ({login, ...rest}) => ({
            ...rest,
            login: {
                login: Credential.sanitize(login),
                loginType: Credential.typeOf(login)
            }
        }),

        redirect: ({login}) => (
            Credential.typeOf(login) === 'phone' &&
                `/signup/${Credential.sanitize(login)}/confirm`
        ),

        keepValues: true
    }

    state = {
        acceptsAgreement: false,
        showsAgreement: false
    }

    handleShowLicenseAgreement = () => (
        this.setState({showsAgreement: true})
    )

    handleCloseLicenseAgreement = (v) => (
        this.setState({acceptsAgreement: v, showsAgreement: false})
    )

    handleSubmitLicenseAgreement = (n, v) => (
        this.setState({acceptsAgreement: v})
    )


    render() {
        const {params} = this.props
        const options = new AuthOptions(params)
        const {acceptsAgreement, showsAgreement, complete} = this.state
        const providersTitle = acceptsAgreement ?
            'Або скористайтесь' : 'Необхідно надати згоду на обробку персональних даних';

        return (
            <div>
                {showsAgreement &&
                    <License onChange={this.handleCloseLicenseAgreement} />
                }

                <Form
                    label="Створити Київ ID"
                    disabled={!acceptsAgreement || complete}
                    onSubmit={this.onSubmit}
                    csrf
                    captcha
                >
                    <Input
                        name='login'
                        type='credential'
                        title='Телефон або Пошта'
                        hint={() => (<PhoneHint />)}
                        tabIndex='1'
                    />

                    <Input
                        name='password'
                        type='password'
                        title='Пароль'
                        validations='isSecure'
                        hint={() => <PasswordHint />}
                        tabIndex='2'
                    />

                    <Checkbox name='acceptsAgreement' onChange={this.handleSubmitLicenseAgreement}>
                        <span id='agreement_checkbox' className={`auth__checkbox-text ${acceptsAgreement && 'animate'}`}>
                            Надаю згоду на обробку <a className="auth__link" onClick={this.handleShowLicenseAgreement}>
                                моїх персональних даних та приймаю правила та умови
                            </a> користуння сервісом
                        </span>
                    </Checkbox>
                </Form>

                {complete &&
                    <div className='auth__repeat-link'>
                        Не надійшов код? <a className="auth__link auth__link-margin" onClick={this.onRepeat1}>
                            Повторити запит
                        </a>
                    </div>
                }

                <Providers
                    title={providersTitle}
                    config={options.providers()}
                    disable={!acceptsAgreement}
                />
            </div>
        );
    }
}
